// global
export const TEXT_MODAL_TITLE = '客戶服務平台'

// login
export const TEXT_LOGOUT_SUCCESSFULLY = '登出成功'
export const TEXT_LOGIN_SUCCESSFULLY = '登入成功'
export const TEXT_PHD_ACCOUNT = '電郵或電話'
export const TEXT_PHD_PASSWORD = '密碼'
export const TEXT_BTN_LOGIN = '登入'
export const TEXT_LINK_FORGET_PWD = '忘記密碼'
// reg
export const TEXT_IPT_EMAIL = '電郵'
export const TEXT_IPT_EMAIL_VCODE = '電郵驗證碼'
export const TEXT_BTN_VCODE = '獲取'
export const TEXT_IPT_PHONE = '電話'
export const TEXT_IPT_PWD = '密碼'
export const TEXT_IPT_PWD_CONFIRM = '確認密碼'
export const TEXT_BTN_REG = '註冊'
// forget pwd
export const TEXT_BTN_FORGET_PWD = '發送重置密碼電郵'
// reset pwd
export const TEXT_RESET_MODAL_TITLE = '重置密碼'

// sidebar
export const TEXT_LABEL_ACCOUNT = '帳户'
export const TEXT_LABEL_COMPANY = '公司'
export const TEXT_TAB_HOMEPAGE = '自助平台主頁'
export const TEXT_TAB_ACCOUNT = '服務賬户'
export const TEXT_SUBTAB_ACCOUNT_INFO = '賬户總覽'
export const TEXT_SUBTAB_ACCOUNT_CONSULT = '賬户咨詢'
export const TEXT_SUBTAB_ACCOUNT_SERVICE = '賬户服務'
export const TEXT_SUBTAB_ACCOUNT_ECARD = '電子客户卡'
export const TEXT_SUBTAB_ACCOUNT_NOTI = '文件通知'
export const TEXT_SUBTAB_ACCOUNT_BILL_AND_RENEW = '賬單與續約'
export const TEXT_SUBTAB_ACCOUNT_PERMISSION = '委派存取權'
export const TEXT_TAB_ACCOUNT_INDIVIDUAL = '個人賬户'
export const TEXT_TAB_WALLET = '錢包'
export const TEXT_TAB_REQUEST_SERVICE = '申請服務'
export const TEXT_TAB_MANUAL = '説明'
export const TEXT_TAB_SUGGESTION_AND_ENQUIRY = '用戶意見/查詢'

// form
export const TEXT_FORM_STEPS_TITLE = [
    '聯絡人資料',
    '*所選擇之服務計劃',
    '成立/購買現成有限公司資料',
    '發行股本',
    '請選擇董事及創辦成員成員數目',
    '增值服務'
];